module.exports = __webpack_public_path__ + "img/chak-pakaal.65820a72.jpg";